import type {ZudokuConfig} from "zudoku";

const config: ZudokuConfig = {
    page: {
        logoUrl: "vilistoLogo2023.svg",
    },
    metadata: {
        favicon: "favicon.svg",
        title: "%s - Vilisto"
    },
    topNavigation: [
        {id: "api", label: "API Reference"},
        {id: "documentation", label: "Documentation"},
    ],
    sidebar: {
        documentation: [
            {
                description: "",
                type: "category",
                label: "Vilisto Customer API",
                items: [
                    "/documentation/introduction",
                    "/documentation/developers",
                ]
            }
        ]
    },
    redirects: [{from: "/", to: "/api"}],
    apis: {
        type: "file",
        input: "./apis/vilisto_backend.yaml",
        navigationId: "api",
    },
    docs: {
        files: "/pages/**/*.{md,mdx}",
    },
};

export default config;
